import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useBoardTabs, { isTabGroup } from './useBoardTabs';
import styles from './BoardTabs.module.scss';

/*
 * ============================================================
 *  ניווט הלוחות במסך צר (HAT-1170)
 * ============================================================
 *
 * שני המפלסים מ-hatzdaka-nedarim (html/pages/dashboard.html):
 * שורת טאבים ראשית — לוח תנועות / הוראות קבע / תמיכה — ומתחתיה,
 * כשהטאב הפעיל הוא קבוצה של לוחות, שורת קפסולות עם הלוחות שבתוכה.
 * «תמיכה» הייתה הקבוצה היחידה; מאז HAT-1135 גם «הוראות קבע» היא
 * קבוצה (אשראי / בנקאי), ולכן שני המפלסים נגזרים מרשימה אחת ב-useBoardTabs.
 *
 * ⚠️ **קישורים, לא כפתורים.** במקור כל הלוחות יושבים בעמוד אחד
 * והטאב מחליף תוכן; כאן כל לוח הוא route משלו, וזו הייתה החלטה
 * מפורשת — הניווט נשאר של האתר, המראה של נדרים. NavLink נותן את
 * שני הדברים: המסך נראה זהה, והכתובת, הרענון וכפתור ה-back
 * ממשיכים לעבוד כמו בכל שאר האתר.
 *
 * מה מוצג ומתי — ר' useBoardTabs.
 */

const BoardTabs = () => {
  const { t } = useTranslation();
  const { isVisible, entries, activeGroup, isOn, hrefOf } = useBoardTabs();

  if (!isVisible) return null;

  return (
    <nav aria-label={t('boardsNav')} className={styles.nav}>
      <div className={styles.tabs}>
        {entries.map((entry) => (isTabGroup(entry) ? (
          /*
           * קבוצה היא כותרת ולא מסך, ולכן היא מובילה ללוח הראשון
           * שבתוכה — כמו לחיצה על הקבוצה בסרגל הצד.
           */
          <NavLink
            key={entry.labelKey}
            to={hrefOf(entry.first.to)}
            className={`${styles.tab} ${entry.isOn ? styles.tabActive : ''}`}
          >
            {t(entry.labelKey)}
          </NavLink>
        ) : (
          <NavLink
            key={entry.to}
            to={hrefOf(entry.to)}
            className={`${styles.tab} ${isOn(entry.to) ? styles.tabActive : ''}`}
          >
            {t(entry.labelKey)}
          </NavLink>
        )))}
      </div>

      {activeGroup && (
        <div className={styles.subTabs}>
          {activeGroup.tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={hrefOf(tab.to)}
              className={`${styles.subTab} ${isOn(tab.to) ? styles.subTabActive : ''}`}
            >
              {t(tab.labelKey)}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};

export default BoardTabs;
